class DeliverySaverBillingAddressController {
    constructor(addressService) {
        this.addressService = addressService;
    }

    $onInit() {
        this.editMode = false;

        this.addressService.getSavedAddresses().then(() => {
            this.savedAddresses = this.addressService.savedAddresses;
            this.billingAddress = this.addressService.getPrimaryAddress();
            this.editMode = !this.billingAddress;
        });
    }

    changeAddress() {
        this.editMode = true;
    }

    tryPushNewAddress(address) {
        if (!this.addressService.savedAddresses.find(x => x.AddressId === address.AddressId)) {
            this.addressService.savedAddresses.push(address);
        }
    }

    saveNewManualAddress(address) {
        this.addressService.saveNewManualAddressForBilling(address)
            .then((addressResponse) => {
                this.billingAddress = addressResponse.Address;
                this.tryPushNewAddress(this.billingAddress);
                this.editMode = false;
            });
    }

    saveNewAutoAddress(address) {
        this.addressService.saveNewAutoAddressForBilling(address)
            .then((addressResponse) => {
                this.billingAddress = addressResponse.Address;
                this.tryPushNewAddress(this.billingAddress);
                this.editMode = false;
            });
    }

    savedAddressSelected(address) {
        if (this.billingAddress.AddressId === address.AddressId) {
            this.editMode = false;
            return;
        }

        this.addressService.setSavedAddressAsBilling(address.AddressId)
            .then(() => {
                this.billingAddress = address;
                this.editMode = false;
            });
    }
}


DeliverySaverBillingAddressController.$inject = ['AddressService'];

const DeliverySaverBillingAddressComponentDefinition = {
    controller: DeliverySaverBillingAddressController,
    template: require('./delivery-saver-billing-address.component.html').trim(),
    bindings: {
        billingAddress: '=',
    },
};

module.exports = {
    DeliverySaverBillingAddressController,
    DeliverySaverBillingAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/billingaddress/delivery-saver-billing-address.component.js